import { format as formatDate } from 'date-fns';
import { de, enGB, ru, uk, ko, ja, zhCN } from 'date-fns/locale';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { selectMemberLang } from '@/state/member/memberSelectors';
import { isValidDate } from '@/lib/helpers/helpers';
import { useCallback, useMemo } from 'react';

const LOCALES = {
    en: enGB,
    ru,
    uk,
    ko,
    ja,
    zh: zhCN,
    de,
};

const useFormatDate = () => {
    const lang = useSelector((state: RootState) => selectMemberLang(state));
    const locale = useMemo(() => {
        const normalizedLang = lang?.split('-')[0];
        return LOCALES[normalizedLang as keyof typeof LOCALES] ?? LOCALES.en;
    }, [lang]);

    const format = useCallback(
        (date: Date, formatter: string) => {
            if (!isValidDate(date)) return 'N/A';
            return formatDate(date, formatter, { locale });
        },
        [locale],
    );

    return { format, locale };
};

export default useFormatDate;
